module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/JUDGEMENT_STYLE.e839aa2f.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/JUDGEMENT_STYLE.png
// module id = 1163
// module chunks = 16